import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4886268b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "プロジェクト", -1))
const _hoisted_2 = { class: "row" }


import { Project } from '@/types/project'
import { NoticeState } from "@/state/NoticeState";
import { ChatDotRound } from '@element-plus/icons';

interface Props {
  projects: Project[];
  show: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    projects: { type: Array, required: true },
    show: { type: Boolean, required: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "container__card" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _withDirectives(_createVNode(_component_el_table, {
        data: __props.projects,
        "empty-text": "プロジェクトが作成されていません。"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, null, {
            default: _withCtx((scope) => [
              _createVNode(_component_router_link, {
                to: { name: 'TimeLines', params: { project_id: scope.row.id } }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(scope.row.name), 1),
                    _createVNode(_component_el_badge, {
                      "is-dot": "",
                      class: "item",
                      hidden: _unref(NoticeState).get(scope.row.id).length == 0
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ChatDotRound))
                      ]),
                      _: 2
                    }, 1032, ["hidden"])
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_vShow, __props.show]
      ])
    ]),
    _: 1
  }))
}
}

})